var _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestricted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.8,41.8l1-12.5c-0.2,0-0.3,0-0.5,0c-0.4,0-0.8,0-1.2-0.1c-0.6,0-1.1-0.1-1.7-0.2l-1,12.3c-2.3-0.3-5.5-1-7-2.6     c-0.3-0.4-1-1.8-1.5-2.8c-1.9-4-4.8-10-10.6-10H34.8c-7,0-9.7,7.5-11.2,11.5c-0.2,0.5-0.4,1-0.6,1.5c-1.5,3.6-3.4,13.1-3.6,14.1     c-0.4,2.1,1,4.2,3.1,4.7c0.3,0.1,0.5,0.1,0.8,0.1c1.9,0,3.5-1.3,3.9-3.2c0.7-3.7,2.2-10.5,3.1-12.6c0.2-0.5,0.4-1,0.6-1.6     l0.3,15.4L27,92.3c-0.3,2.5,1.5,4.8,4.1,5.1c2.5,0.3,4.8-1.5,5.1-4.1l3.9-33.2l3.9,33.2c0.3,2.4,2.3,4.1,4.6,4.1     c0.2,0,0.4,0,0.5,0c2.5-0.3,4.4-2.6,4.1-5.1l-4.3-36.6L49.2,40c0.8,1.6,1.5,3.1,2.5,4.1c3.4,3.7,9,4.8,12.2,5.1l-3.8,46.3     c-0.1,0.9,0.6,1.7,1.5,1.8c0.9,0.1,1.7-0.6,1.8-1.5l3.8-46.6c1.7-0.4,3-2,3-3.8C70.2,43.8,69.2,42.4,67.8,41.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 40.1,
    cy: 14.7,
    r: 9.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f00",
    d: "M69.3,2.5C62.6,2,56.6,7,56.1,13.8c-0.5,6.8,4.5,12.7,11.3,13.3c6.8,0.5,12.7-4.5,13.3-11.3C81.1,9,76.1,3.1,69.3,2.5z      M74.9,11l-4.7,4l4,4.7c0.2,0.2,0.1,0.5-0.1,0.6l-1.4,1.2c-0.2,0.2-0.5,0.1-0.6-0.1l-4-4.7l-4.7,4c-0.2,0.2-0.5,0.1-0.6-0.1     l-1.2-1.4c-0.2-0.2-0.1-0.5,0.1-0.6l4.7-4l-4-4.7c-0.2-0.2-0.1-0.5,0.1-0.6l1.4-1.2c0.2-0.2,0.5-0.1,0.6,0.1l4,4.7l4.7-4     c0.2-0.2,0.5-0.1,0.6,0.1l1.2,1.4C75.1,10.6,75.1,10.8,74.9,11z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricted);
export default __webpack_public_path__ + "static/media/restricted.01cc32646dae1c4fab945168fdbd12de.svg";
export { ForwardRef as ReactComponent };